import React from "react";

/**
 * @component CalendarAddXIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CalendarAddXIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CalendarAddXIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CalendarAddXIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M7 2v2h10V2h2v2h1a2 2 0 012 2v6h-2V9H4v11h8v2H4a2 2 0 01-2-2V6a2 2 0 012-2h1V2h2zm12 12v3h3v2h-3v3h-2v-3h-3v-2l3-.001V14h2zm-9.586-3.828l1.414 1.414L9.414 13l1.414 1.414-1.414 1.414L8 14.414l-1.413 1.414-1.414-1.414L6.585 13l-1.413-1.413 1.414-1.414L8 11.586l1.414-1.414z"
        fillRule="evenodd"
      />
    </svg>
  )
);
CalendarAddXIcon.displayName = "CalendarAddXIcon";
export default CalendarAddXIcon;
